<template>
  <div class="container">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多的报告了" @load="onLoad">
      <div class="resultItem line-b-E5E5E5 bg-fff" :class="index != list.length-1?'mb10':''" v-for="(item,index) in list" :key="item.elementId">
        <ul>
          <li class="flex"><span class="resultItemTitle">项目名</span>：{{item.elementName}}</li>
          <li class="flex mt10"><span class="resultItemTitle">结果</span>：
            <!-- resultType 为1是数值 2是文本 3是文件 -->
            <p class="flexCenter" v-if="item.resultType == 1">
              <span>{{item.resultContent}}</span>
              <span class="color-red" v-if="item.positiveSymbol.indexOf('H') > -1">&nbsp;↑</span>
              <span class="color-red" v-if="item.positiveSymbol.indexOf('L') > -1">&nbsp;↓</span>
            </p>
            <p class="flexCenter" v-if="item.resultType == 2">
              <span>{{item.resultContent}}</span>
              <span class="color-red" v-if="item.positiveSymbol.indexOf('A') > -1">&nbsp;!</span>
            </p>
            <p class="flexCenter" v-if="item.resultType == 3">
              <span @click="fileDownload(item2.resultContent)">查看</span>
            </p>
          </li>
          <li class="flex mt10"><span class="resultItemTitle">单位</span>：{{item.unit}}</li>
          <li class="flex mt10"><span class="resultItemTitle">参考范围</span>：{{item.referenceShow}}</li>
          <li class="flex mt10 mb10"><span class="resultItemTitle">检查日期</span>：{{item.examTime}}</li>
        </ul>
        <div class="operationBox flex">
          <p class="attention" :class="item.topElementShow == 1?'isAttention':''" @click="isAddIndex(item.elementId,item.topElementShow,index)">首页</p>
          <p class="historyTrend" v-if="item.resultType == 1" @click="resultTrend(item.elementId,item.elementName)">查看历史趋势</p>
        </div>
      </div>
    </van-list>
    <div v-if="isShowEmit">
      <van-empty class="custom-image" :image="emptyImg" description="没有数据" />
    </div>
     <v-goTop :top="scroll_top" @func="getMsgFormSon"></v-goTop>
  </div>
</template>
<script>
  import { Button,Toast,List ,Empty} from "vant";
  import GoTop from "@/components/GoTop";
  export default {
  name: 'ResultList',
  components: {
    [Toast.name]:Toast,
    [Button.name]:Button,
    [List.name]:List,
    [Empty.name]:Empty,
    'v-goTop': GoTop,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      isShowEmit:false,
      emptyImg:require('@/assets/images/empty.png'),
      page:1,
      limit:10,
      scroll_top: '',
      msgFormSon: '',
    }
  },
  watch: {
    
  },
  created() {
    
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        this.getList()
        this.loading = true
      }, 1000);
    },
    getList(){
      $.ajax({
        url: this.GLOBAL.url + '/wx/latestResult',
        type: 'get',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {
          pageNum:this.page,
          pageSize:this.limit,
          queryTop:0,//0包含首页显示与未显示 1首页显示的
        },
        success: (res) => {
          if (res.code == 200) {
            this.loading = false;
            this.list = this.list.concat(res.data.list);
            this.page ++;
            //没有数据
            if (this.list.length === 0 && this.page === 1) {
              this.isShowEmit = true
            };
            //是否最后一页
            if(res.data.isLastPage){
              this.finished = true;
            };
          } else {
            Toast(res.msg)
          };
        },
        error: (e) => {
          console.log(e);
        }
      })
    },
    /*是否添加首页*/
    isAddIndex(id,type,index){
      $.ajax({
        url: this.GLOBAL.url + '/wx/topElement',
        type: 'get',
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        data: {
          elementId:id,//项目指标id
          status:type == 0?1:0//0取消首页关注 1首页关注
        },
        success: (res) => {
          if (res.code == 200) {
            this.$set(this.list[index],'topElementShow',type == 0?1:0);
            Toast(res.msg);
          } else {
            Toast(res.msg)
          };
        },
        error: (e) => {
          console.log(e);
        }
      })
    },
    getMsgFormSon(data) {
      var self = this;
      self.msgFormSon = data;
      let timer = null;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (self.msgFormSon > 0) {
          self.msgFormSon -= 50;
          $('#roll').scrollTop(self.msgFormSon)
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
        }
      });
    },
    /*查看文件*/
    fileDownload(filename){
      if(filename){
        $.ajax({
          url: this.GLOBAL.aliyunOssUrl + '/getAccessUrl',
          type: 'get',
          xhrFields: {
            withCredentials: true
          },
          data: {
           bucketName:'jk-test1',
           objectName:filename
          },
          crossDomain: true,
          success: (res) => {
            if (res.code == 200) {
              window.top.location.href= res.data.url;
            } else {
              this.$toast(res.msg)
            };
          
          },
          error: (e) => {
            console.log(e);
          }
        })
      }else{
        Toast('文件名不可为空！');
      }
    },
    resultTrend(id,name){
      this.$router.push({name:'ResultTrend',query:{id:id,name:name}})
    },
  },
  computed: {

  },
}</script>
<style type="text/css" scoped>
.container {
  width: 100%;
  height: 100%;
}

.resultBox {
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  padding: 0.533333rem 0;
  border: 0.026667rem solid #E5E5E5;
  border-radius: 0.266667rem;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
}

.resultItem {
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  padding: 0.266667rem;
  border: 0.026667rem solid #E5E5E5;
  border-radius: 0.266667rem;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
}

.resultItemTitle {
  text-align-last: justify;
  -moz-text-align-last: justify;
  text-align: justify;
  text-justify: distribute-all-lines;
  display: block;
  flex: 0 0 2.133333rem;
  width: 4.0rem
}

.operationBox {
  padding-top: 0.266667rem;
  border-top: 0.026667rem solid #e5e5e5;
}

.attention {
  padding: 0.133333rem 0.533333rem;
  border: 0.026667rem solid #e5e5e5;
  border-radius: 0.133333rem;
}

.isAttention {
  border: 0.026667rem solid #1989fa;
  color: #1989fa;
}

.historyTrend {
  padding: 0.133333rem 0.533333rem;
  margin-left: 0.533333rem;
  border: 0.026667rem solid #E5E5E5;
  border-radius: 0.133333rem;
}

.custom-image .van-empty__image {
  width: 90px;
  height: 90px;
}
</style>